/** Browser-safe credential lifecycle values mirrored by Prisma. */
export const CredentialType = {
    PHYSICAL_TERMINAL: 'PHYSICAL_TERMINAL',
    VIRTUAL_TERMINAL: 'VIRTUAL_TERMINAL',
    IPX: 'IPX',
} as const;

export type CredentialType = keyof typeof CredentialType;

export const IpxCredentialDefinitionKind = {
    WEB_LOGIN_WORKFLOW: 'WEB_LOGIN_WORKFLOW',
    MACHINE_AUTH: 'MACHINE_AUTH',
} as const;

export type IpxCredentialDefinitionKind = keyof typeof IpxCredentialDefinitionKind;

export const CredentialRotationAttemptState = {
    CREATED: 'CREATED',
    INJECTED: 'INJECTED',
    SUBMITTED: 'SUBMITTED',
    PROMOTED: 'PROMOTED',
    PROMOTION_FAILED: 'PROMOTION_FAILED',
    FAILED: 'FAILED',
    EXPIRED: 'EXPIRED',
    ABANDONED: 'ABANDONED',
} as const;

export type CredentialRotationAttemptState = keyof typeof CredentialRotationAttemptState;
